var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasBuyingPrice)?_c('el-tooltip',{attrs:{"content":_vm.buyingPriceLabel,"placement":"top"}},[_c('span',[_vm._v(_vm._s(_vm.params.data.supplierName))])]):_c('span',[_vm._v(_vm._s(_vm.params.data.supplierName))])}
var staticRenderFns = []

export { render, staticRenderFns }